import React from 'react';
import clsx from 'clsx';
import { DateUtils } from 'react-day-picker';
import { t } from 'ttag';
import DaysDatePicker from '@components/Schedules/components/DaysDatePicker';
import TimePickerRow from '@components/Schedules/components/TimePickerRow';
import ScheduleNameRow from '@components/Schedules/components/ScheduleNameRow';
import { useStyles } from './styles';

/**
 * The schedule's own fields - name, active toggle, days/dates tab, and time -
 * shown above the per-register Actions list. Disabled (pointer-events none)
 * for a power-meter fallback unit, whose schedules are view/delete-only.
 */
const ScheduleFormFields = ({
  scheduleName,
  onNameChange,
  scheduleDisabled,
  onDisabledChange,
  tab,
  onTabChange,
  days,
  onDaysChange,
  dates,
  onDatesChange,
  powerOnTime,
  onTimeChange,
  is12Hours,
  isPowerMeterUnit,
}) => {
  const classes = useStyles();

  const handleDayClick = (date, { selected }) => {
    const selectedDates = dates.concat();
    if (selected) {
      const selectedIndex = selectedDates.findIndex((selectedDate) =>
        DateUtils.isSameDay(selectedDate, date)
      );
      selectedDates.splice(selectedIndex, 1);
    } else {
      selectedDates.push(date);
    }
    onDatesChange(selectedDates);
  };

  const handleAddRemoveDay = (day) => {
    const newDays = days.includes(day)
      ? days.filter((d) => d !== day)
      : [...days, day];
    onDaysChange(newDays);
  };

  return (
    <div className={clsx(isPowerMeterUnit && classes.disabled)}>
      <ScheduleNameRow
        name={scheduleName}
        onNameChange={onNameChange}
        disabled={scheduleDisabled}
        onDisabledChange={onDisabledChange}
      />

      <DaysDatePicker
        tab={tab}
        onTabChange={onTabChange}
        days={days}
        dates={dates}
        onAddRemoveDay={handleAddRemoveDay}
        onDayClick={handleDayClick}
      />

      <TimePickerRow
        id={'time-picker'}
        currentValue={powerOnTime}
        label={t`Schedule Time`}
        handleTimeChange={onTimeChange}
        is12Hours={is12Hours}
      />
    </div>
  );
};

export default ScheduleFormFields;
